import { Link } from 'react-router-dom';
import { Hero } from '../components/Hero';
import './Legal.css';

export function TermsOfUse() {
  return (
    <div className="legal">
      <Hero
        title="Terms of Use"
        subtitle="Please read these terms before using this website"
        size="small"
      />

      <section className="legal__content">
        <div className="container container--narrow">
          <p className="legal__meta">
            <strong>Effective Date:</strong> February 26, 2026
          </p>

          <p className="legal__intro">
            Welcome to Notation of Being. By accessing or using this website, you agree to the
            following terms.
          </p>

          <h2>1. Intellectual Property</h2>
          <p>
            All content on this Site — including text, graphics, logos, designs, blog posts,
            audio, and digital materials — is the property of Notation of Being LLC unless
            otherwise noted.
          </p>
          <p>
            Content may not be reproduced, distributed, or modified without written permission.
          </p>

          <h2>2. Permitted Use</h2>
          <p>You may:</p>
          <ul>
            <li>Read, share, and link to public content</li>
            <li>Subscribe to email updates</li>
            <li>Contact us for inquiries</li>
          </ul>
          <p>You may not:</p>
          <ul>
            <li>Use content for commercial purposes without permission</li>
            <li>Attempt to hack, disrupt, or misuse the Site</li>
            <li>Scrape content for redistribution</li>
          </ul>

          <h2>3. No Professional Advice</h2>
          <p>
            Content on this Site is for informational and educational purposes only.
          </p>
          <p>
            Nothing on this Site constitutes legal, financial, medical, or professional advice.
          </p>

          <h2>4. Limitation of Liability</h2>
          <p>Notation of Being LLC is not liable for:</p>
          <ul>
            <li>Any indirect, incidental, or consequential damages</li>
            <li>Errors or omissions in content</li>
            <li>Actions taken based on Site information</li>
          </ul>
          <p>Use of the Site is at your own discretion and risk.</p>

          <h2>5. External Links</h2>
          <p>
            The Site may contain links to third-party websites. We are not responsible for the
            content or privacy practices of external sites.
          </p>

          <h2>6. Modifications</h2>
          <p>
            We reserve the right to update these Terms at any time. Continued use of the Site
            constitutes acceptance of updated Terms.
          </p>

          <h2>7. Governing Law</h2>
          <p>
            These Terms shall be governed by the laws of the State of Texas, without regard to
            conflict of law principles.
          </p>

          <h2>8. Contact</h2>
          <address className="legal__address">
            <strong>Notation of Being LLC</strong><br />
            Email: <a href="mailto:contact@notationofbeing.com">contact@notationofbeing.com</a><br />
            Website: <a href="https://www.notationofbeing.com">https://www.notationofbeing.com</a>
          </address>

          <p>
            <Link to="/privacy">View our Privacy Policy</Link>
          </p>
        </div>
      </section>
    </div>
  );
}
